import type { SelectOption } from '@movingimage-evp/mi-ui-component-library';

import type { TranscodingProfile } from '../../../generated/graphql-manager';

import { useGetLsproDefaultSettingsQuery } from '../../../generated/graphql-manager';
import { useCurrentUser } from '../current-user';

export function useStreamingProfiles(): SelectOption[] {
  const { lsproId } = useCurrentUser();
  const { data } = useGetLsproDefaultSettingsQuery({ variables: { lsproId } });

  const transcodingProfile = data?.configuration.transcodingProfile;
  const customProfiles = data?.lsproSettings?.transcodingProfileSettings?.customProfiles;
  const profiles: TranscodingProfile[] = [transcodingProfile, ...(customProfiles || [])].filter(
    (item) => item !== undefined
  );

  return profiles.map((profile) => ({
    key: profile.id,
    label: profile.name,
    hint: profile.settings.description,
  }));
}
